var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showGoalSection || _vm.showPropertySection
    ? _c(
        "b-row",
        { staticClass: "group-wrapper p-4 card" },
        [
          _vm.showGoalSection
            ? _c(
                "page-section-group-layout",
                { attrs: { "show-divider": "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "section-title",
                            { attrs: { "title-type": "subtitle" } },
                            [
                              _vm.isPurchaseFlow
                                ? _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "application-standalone.pages.submit.yourGoalIsToPurchase"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "application-standalone.pages.submit.yourGoalIsTo",
                                            {
                                              goal: _vm.goal.toLowerCase(),
                                            }
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]),
                              _vm._v(" "),
                              _vm.hasMissingInformation
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "span",
                                        { attrs: { id: "goalTooltipTarget" } },
                                        [
                                          _c("icon", {
                                            staticClass:
                                              "text-danger clickable",
                                            attrs: {
                                              name: "exclamation-circle",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("notification-popover", {
                                        attrs: { target: "goalTooltipTarget" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "popoverContent",
                                              fn: function () {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "application-standalone.pages.pleaseReviewThisSection"
                                                      )
                                                    ) + "\n              "
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1872172473
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showPurchasePrice
                            ? _c("p", [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-form.purchase-price"
                                        )
                                      ) +
                                      ":\n          "
                                  ),
                                ]),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm._f("formatMoneyValueLong")(
                                        _vm.purchasePrice
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "auto" } }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary text-capitalize skip-disable-all-inputs",
                            on: {
                              click: function ($event) {
                                return _vm.$emit("edit")
                              },
                            },
                          },
                          [
                            _vm.allowEdit
                              ? _c("icon", {
                                  staticClass: "text-primary mr-1",
                                  attrs: { name: "pencil" },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.editButtonText) +
                                "\n        "
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showPropertySection
            ? _c(
                "page-section-group-layout",
                { attrs: { "show-divider": "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "section-title",
                            { attrs: { "title-type": "subtitle" } },
                            [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.addressTitle) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              !_vm.formattedAddress && _vm.PROPERTY_REQUESTED
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { id: "addressTooltipTarget" },
                                        },
                                        [
                                          _c("icon", {
                                            staticClass:
                                              "text-danger clickable",
                                            attrs: {
                                              name: "exclamation-circle",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("notification-popover", {
                                        attrs: {
                                          target: "addressTooltipTarget",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "popoverContent",
                                              fn: function () {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "application-standalone.pages.pleaseReviewThisSection"
                                                      )
                                                    ) + "\n              "
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1872172473
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.formattedAddress
                            ? _c("p", { staticClass: "text-light-gray" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.noAddressSubtitle) +
                                    "\n        "
                                ),
                              ])
                            : _c("p", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.formattedAddress) +
                                    "\n        "
                                ),
                              ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.PROPERTY_REQUESTED
                        ? _c("b-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary text-capitalize skip-disable-all-inputs",
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("edit")
                                  },
                                },
                              },
                              [
                                _vm.allowEdit
                                  ? _c("icon", {
                                      staticClass: "text-primary mr-1",
                                      attrs: { name: "pencil" },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.editButtonText) +
                                    "\n        "
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }